<template>
  <aside  class="w-56 p-4 space-y-1 border-r border-gray-200 bg-white shrink-0 relative z-30">
    <ul role="list">
      <PageItem
        v-for="item in pages"
        v-bind="item"
        :selected="item.id === selected"

        @click.native="selected = item.id"
      />
    </ul>
  </aside>
</template>

<script>

import PageItem from "./PageItem.vue"

export default {
  components: {
    PageItem,
  },
  created() {
    const id = this.selected
    this.$emit("input", this.pages.find(page => page.id === id) || {})
  },
  data() {
    return {
      selected: "header-no-reformatting",
      pages: [
        {
          name: "Header no formatting",
          id: 'header-no-reformatting',
          orig_template_code:"design_email_header_template",
          template: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>

    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="initial-scale=1.0, width=device-width" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="x-apple-disable-message-reformatting" />
    <style type="text/css">

        {{var template_styles|raw}}



        {{css file="css/email.css"}}

    </style>
</head>

<body>
    {{inlinecss file="css/email-inline.css"}}


    <!-- Begin wrapper table -->
    <table class="wrapper" width="100%">
        <tr>
            <td class="wrapper-inner" align="center">
                <table class="main" align="center">
                    <tr>
                        <td class="header">
                            <a class="logo" href="{{store url=""}}">
                                <img {{if logo_width}} width="{{var logo_width}}" {{else}} width="180" {{/if}} {{if logo_height}} height="{{var logo_height}}" {{/if}} src="{{var logo_url}}" alt="{{var logo_alt}}" border="0" />
                            </a>
                        </td>
                    </tr>

                    <tr>
                        <td class="main-content">
                            <!-- Begin Content -->`
        },
        {
          id: "new-invoice",
          name: "New Invoice",
          orig_template_code:"sales_email_invoice_template",
          template: `{{template config_path="design/email/header_template"}}

<table>
    <tr class="email-intro">
        <td>
            <p class="greeting">Assalaamoe 'alaykoem {{trans "%name," name=$order_data.customer_name}}</p>
            <p>We hebben je bestelling ontvangen en gaan direct voor je aan de slag. Je ontvangt van ons een verzendbevestiging met track & trace-gegevens zodra je bestelling bij PostNL is in sha Allah.
            </p>

            <p>Met je pakketje geven we nooit een factuur of een pakbon mee, dus voor cadeautjes heel handig. In de bijlage van deze e-mail kun je je factuur terugvinden.</p>
        </td>
    </tr>

    <tr class="email-summary">
        <td>
            <h1>{{trans "Your Invoice #%invoice_id for Order #%order_id" invoice_id=$invoice.increment_id order_id=$order.increment_id}}</h1>
        </td>
    </tr>

    <tr class="email-information">
        <td>
            {{depend comment}}
            <table class="message-info">
                <tr>
                    <td>
                        {{var comment|escape|nl2br}}
                    </td>
                </tr>
            </table>

            {{/depend}}

            <table class="order-details">
                <tr>
                    <td class="address-details">
                        <h3>{{trans "Billing Info"}}</h3>
                        <p>{{var formattedBillingAddress|raw}}</p>
                    </td>
                    {{depend order_data.is_not_virtual}}
                    <td class="address-details">
                        <h3>Bezorg adres</h3>
                        <p>{{var formattedShippingAddress|raw}}</p>
                    </td>
                    {{/depend}}
                </tr>

                <tr>
                    <td class="method-info">
                        <h3>{{trans "Payment Method"}}</h3>
                        {{var payment_html|raw}}
                    </td>
                    {{depend order_data.is_not_virtual}}
                    <td class="method-info">
                        <h3>{{trans "Shipping Method"}}</h3>
                        <p>PostNL</p>
                    </td>
                    {{/depend}}
                </tr>

            </table>

            {{layout area="frontend" handle="sales_email_order_invoice_items" invoice_id=$invoice_id order_id=$order_id}}
        </td>
    </tr>
</table>

{{template config_path="design/email/footer_template"}}`,
        },
        {
          id: "new-shipment",
          name: "New Shipment",
          orig_template_code:"sales_email_shipment_template",
          template: `{{template config_path="design/email/header_template"}}

<table>

    <tr class="email-intro">
        <td>
            <p class="greeting">Assalaamoe 'alaykoem {{trans "%name," name=$order_data.customer_name}}</p>
            <p>
                {{trans "Jouw bestelling met bestelnummer #%order_id is verzonden met PostNL" order_id=$order.increment_id}}

                {{layout handle="sales_email_order_shipment_track" shipment_id=$shipment_id order_id=$order_id}}
            </p>
        </td>
    </tr>

</table>

{{template config_path="design/email/footer_template"}}`,
        },
      ],
    }
  },
  watch: {
    selected(id) {
      this.$emit("input", this.pages.find(page => page.id === id) || {})
    },
  },
}

</script>
